<template>
  <div class="lead-head-container row">
    <div class="col-lg-5 col-xs-12 pull-right feature-block">
      <h5>Statut : </h5>

      <div style="display:flex;">
        <div style="width: 100%; padding-right: 10px;">
          <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="selected_state = $event.new_value ? $event.new_value.value : -1">
          </custom-select>
        </div>
        <div style="margin-left: auto;">
          <button class="btn btn-success"
                  @click="$emit('show-modal-lead', {lead_id:current_lead.id, status:selected_state, closing_reason:current_lead.closing_reason})">
                  Modifier
          </button>
        </div>
      </div>

      <div style="margin-top: 10px;">
        <div v-if="current_lead.status == 'closed'">
          <span> Raison de la fermeture : <strong>{{current_lead.decoded_closing_reason}}</strong></span><br>
          <span> Commentaire concernant la fermeture : <strong>{{current_lead.closing_message}}</strong></span>
        </div>

        <div v-else-if="current_lead.status == 'duplicate'">
          <span> Doublon du lead (ID) : <strong>{{ current_lead.closing_message }}</strong></span><br>
        </div>
      </div>
    </div>

    <div class="col-lg-7 col-xs-12 feature-block">
      <h5>Identité :</h5>
      <div v-if="editing">
        <h4>Edition des informations d'un LEAD :</h4>
        <div style="display:flex;">
          <div style="width:50%;margin-right:5px;">
            <div class="form-group" >
              <label>Raison sociale :</label>
              <custom-text :field="fields[9]" :value="fields[9].value" :field_idx="9" @field-updated="local.contact_company_name = $event.new_value">
              </custom-text>
            </div>

            <div class="form-group">
              <label>Civilité :</label>
              <custom-select :field="fields[2]" :value="fields[2].value" :field_idx="2" @field-updated="local.contact_civility = $event.new_value ? $event.new_value.value : null">
              </custom-select>
            </div>

            <div class="form-group" >
              <label>Prénom :</label>
              <custom-text :field="fields[3]" :value="fields[3].value" :field_idx="3" @field-updated="local.contact_first_name = $event.new_value">
              </custom-text>
            </div>

            <div class="form-group" >
              <label>Nom :</label>
              <custom-text :field="fields[4]" :value="fields[4].value" :field_idx="4" @field-updated="local.contact_last_name = $event.new_value">
              </custom-text>
            </div>

            <div class="form-group" >
              <label>Téléphone. :</label>
              <custom-text :field="fields[7]" :value="fields[7].value" :field_idx="7" @field-updated="local.contact_phone = $event.new_value">
              </custom-text>
            </div>

            <div class="form-group" >
              <label>Email :</label>
              <custom-text :field="fields[8]" :value="fields[8].value" :field_idx="8" @field-updated="local.contact_email = $event.new_value">
              </custom-text>
            </div>
          </div>
          <div style="width:50%;">
            <div class="form-group">
              <label>Comment nous a t-il connu :</label>
              <custom-select :field="fields[1]" :value="fields[1].value" :field_idx="1" @field-updated="local.origin_supplement_key = $event.new_value ? $event.new_value.value : null">
              </custom-select>
            </div>
            <div class="form-group">
              <label>Complément :</label>
              <custom-text :field="fields[5]" :value="fields[5].value" :field_idx="5" @field-updated="local.contact_supplement = $event.new_value">
              </custom-text>
            </div>
            <!-- <div class="form-group">
              <label>Message :</label>
              <custom-text-area :field="fields[6]" :value="fields[6].value" :field_idx="6" @field-updated="local.origin_message = $event.new_value" style="height:177px;width:377px;">
              </custom-text-area>
            </div> -->

          </div>
        </div>
        <div>
          <button class="btn btn-default" @click="reset_local()">Annuler</button>
          <button class="btn btn-success" @click="try_edition()">Valider</button>
        </div>
      </div>
      <div v-else class="head-view">
        <div>
          <div style="display:flex;">
            <i v-if="current_lead.status == 'open'" class="fa fa-circle" style="color:#10CFBD;align-self: center;"></i>
            <i v-else-if="current_lead.status == 'in_progress'" class="fa fa-circle" style="color:#F8D053;align-self: center;"></i>
            <i v-else-if="current_lead.status == 'closed' || current_lead.status == 'duplicate'" class="fa fa-circle b-grey" style="align-self: center;"></i>
            <i v-else-if="current_lead.status == 'completed'" class="fa fa-circle"
               style="color:#a1733f;align-self: center;"></i>
            <i v-else-if="current_lead.status == 'converted'" class="fa fa-circle" style="color:#48B0F7;align-self: center;"></i>
            <h4 v-if="displayedName.length > 0"><span>{{ displayedName }}</span></h4>
          </div>
          <div v-if="current_lead.contact_phone">
            <strong class="red-font">Tél:</strong> <span v-if="current_lead.contact_phone">{{current_lead.contact_phone}}</span>
          </div>
          <div v-if="current_lead.contact_email">
            <strong class="red-font">@ :</strong> <span v-if="current_lead.contact_email">{{current_lead.contact_email}}</span>
          </div>
          <div v-if="current_lead.decoded_origin_supplement">
            <strong>Comment nous a t-il connu :</strong>
            <span>{{ current_lead.decoded_origin_supplement }}</span>
          </div>
          <div>
            <span v-if="current_lead.contact_supplement">Complément : {{current_lead.contact_supplement}}</span>
            <p v-if="current_lead.origin_message">
              <strong>Message</strong>:{{current_lead.origin_message}}
            </p>
          </div>
        </div>
        <div style="margin-left:auto;">
          <button class="btn btn-success" v-if="!closedLead" @click="editing=true">Modifier</button>
        </div>
      </div>
      <div class="head-complement">
        <p>
          Crée le {{ current_lead.created_at | moment-date  }}
          <span v-if="get_email_of()"> par {{ get_email_of() }}</span>
          <strong v-if="current_lead.author" style="font-color:red;"> ASSISTANT : {{current_lead.author}}</strong>
        </p>
        <p v-if="current_lead.last_updating_status_user">
          Statut mis à jour la dernière fois par {{ current_lead.last_updating_status_user.email }}
        </p>
        <p>
          Depuis {{ current_lead.decoded_origin }}
          <span v-if="current_lead.purchase_tunnel_step"><br/>Etape courante : {{ current_lead.purchase_tunnel_step }}</span>
        </p>
      </div>
    </div>

    <div class="col-xs-12"><hr></div>
  </div>
</template>
<script>

import {mapGetters, mapActions} from "vuex"

import CustomText from "components/Forms/Elements/Text"
import CustomTextArea from "components/Forms/Elements/TextArea"
import CustomSelect from "components/Forms/Elements/Select"
import api from '../../../client/store/api'

export default {
  name:"LeadHead",
  data(){
    return {
      editing:false,
      selected_state:-1,
      available_states:[
        {id:"open", text:"Ouvert"},
        {id:"completed", text:"Contrat complété"},
        {id:"in_progress", text:"En cours"},
        {id:"converted", text:"Converti"},
        {id:"duplicate", text:"Doublon"},
        {id:"closed", text:"Abandonné"},
      ],
      options_origins:[],
      available_civilities:[
        {id:"mr", text:"M."},
        {id:"mrs", text:"Mme."}
      ],
      local:{
        contact_company_name:null,
        contact_civility:null,
        contact_first_name:null,
        contact_last_name:null,
        contact_phone:null,
        contact_email:null,
        contact_supplement:null,
        origin_message:null,
        origin_supplement_key:null,
      }
    }
  },
  components:{
    CustomTextArea,
    CustomText,
    CustomSelect,
  },
  methods:{
    ...mapActions("crm", ["update_lead"]),

    get_email_of(){
      return (this.current_lead.creating_user != null) ? this.current_lead.creating_user.email : null
    },

    try_edition()
    {
      this.update_lead({lead_id:this.current_lead.id, body:{
        contact_company_name:this.local.contact_company_name,
        contact_civility:this.local.contact_civility,
        contact_first_name:this.local.contact_first_name,
        contact_last_name:this.local.contact_last_name,
        contact_phone:this.local.contact_phone,
        contact_email:this.local.contact_email,
        contact_supplement:this.local.contact_supplement,
        origin_message:this.local.origin_message,
        origin_supplement_key:this.local.origin_supplement_key
      }})
      .then(() => {
        this.$emit('reload-lead')
      })
    },

    reset_local()
    {
      this.local.contact_company_name=this.current_lead.contact_company_name,
      this.local.contact_civility=this.current_lead.contact_civility,
      this.local.contact_first_name=this.current_lead.contact_first_name,
      this.local.contact_last_name=this.current_lead.contact_last_name,
      this.local.contact_phone=this.current_lead.contact_phone,
      this.local.contact_email=this.current_lead.contact_email,
      this.local.contact_supplement=this.current_lead.contact_supplement,
      this.local.origin_message=this.current_lead.origin_message,
      this.local.origin_supplement_key=this.current_lead.origin_supplement_key
      this.editing=false
    },

    fetchOriginSupplementKeys() {
      const params = {
        type: "customer_origin"
      }

      api.fetchSettings(params)
        .then((response) => this.options_origins = response.data.settings)
        .catch((error) => state.errors.push(error.response.data.errors))
    }
  },

  computed:{
    ...mapGetters("crm", ["current_lead","is_fetching","is_any_errors","errors"]),
    getOrigins() {
        // Deactivated origins can no longer be selected, except the one the lead already holds
        let selectable_origins = _.filter(this.options_origins, (origin) => (
            origin.active || origin.key === this.current_lead.origin_supplement_key
        ))

        let origins = _.map(selectable_origins, (origin) => (
            {
                id: origin.key,
                text: origin.value
            }
        ))

        return origins;
    },
    fields(){

      let v = [
        {values:this.available_states, multiple:false, placeholder:"Modifier l'etat de ce lead", disabled:this.is_fetching, idx:0, required:false, value:this.current_lead.status, label:"Etat",type:"select"},
        {values:this.getOrigins, multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:this.local.origin_supplement_key, label:"Origine",type:"select"},
        {values:this.available_civilities, multiple:false, placeholder:"", disabled:(this.is_fetching || !this.editing), idx:2, required:false, value:this.local.contact_civility, label:"Origine",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:false, value:this.local.contact_first_name, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:4, required:false, value:this.local.contact_last_name, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:5, required:false, value:this.local.contact_supplement, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:6, required:false, value:this.local.origin_message, label:"",type:"textarea"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:false, value:this.local.contact_phone, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:4, required:false, value:this.local.contact_email, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:9, required:false, value:this.local.contact_company_name, label:"",type:"text"},

      ]
      return v
    },

    displayedName() {
      let displayedName = ''

      if ( this.current_lead.contact_company_name )
        displayedName += this.current_lead.contact_company_name

      if ( this.current_lead.contact_first_name || this.current_lead.contact_last_name )
      {
        if ( displayedName.length > 0 )
          displayedName += ' - '

        if ( this.current_lead.contact_civility )
          displayedName += `${this.current_lead.decoded_contact_civility} `

        if ( this.current_lead.contact_first_name )
          displayedName += `${this.current_lead.contact_first_name} `

        if ( this.current_lead.contact_last_name )
          displayedName += `${this.current_lead.contact_last_name} `
      }

      if ( displayedName.length == 0 )
        displayedName = 'Identité non renseignée'

      return displayedName
    },

    closedLead() {
      return 'closed' == this.current_lead.status
    }
  },

  mounted() {
    this.reset_local()
    this.fetchOriginSupplementKeys()
  },

  watch :{
    current_lead: function() {
      this.reset_local()
    }
  }
}
</script>

<style scoped lang="scss">
h5 {
  color: #fb557a;
  text-transform: uppercase;
}

.red-font {
  color:#fb557a;
}

.head-view {
  display: flex;
}

.head-complement {
  margin-top: 15px;

  p { margin-bottom: 0; }
}

.lead-head-container {
  background-color: white;

  .feature-block {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadHead.vue